import React from 'react';
import {
  withRouter,
} from 'react-router-dom';
import {
  Link,
  Grid,
  Typography,
} from '@material-ui/core';

import translations from '../../languages/i18n';
import { noMatch } from '../../styles/formElementsStyles';

function UseApp() {
  const noMatchStyle = noMatch();
  return (
    <div className={noMatchStyle.content}>
      <Grid container direction='column' spacing={2} alignItems='center' justify='center'>
        <Grid item>
          <img src={require('../../assets/images/logoHT.png')} alt='HT Logo' width='150' heigth='150' />
        </Grid>
        <Grid item>
          <Typography component='h1' variant='h5'>{translations['_useApp']}</Typography>
          <Typography variant='body1'>{translations['_getAppFromStores']}</Typography>
          <Link href='https://play.google.com/store/apps' component='a' variant='body1'>Google Play (Android)</Link>
          <br />
          <Link href='https://www.apple.com/app-store/' component='a' variant='body1'>App Store (iOS)</Link>
        </Grid>
      </Grid>
    </div>
  );
}

export default withRouter(UseApp);
